export default __webpack_public_path__ + "static/media/back_to_school.eef4fc2e.png";